import React from "react";
import "./DayPicker.scss";

const iconSrc = require.context(
  "../../Icons/images/weatherIcons/",
  true,
  /\.(png|svg|jpg|gif)$/
);

const WeatherDisplay = (props) => {
  if (props.futureMode || !props.weather) return <div />;

  const wind = (Math.round(props.weather.windSpeed * 10) / 10).toFixed(1);
  const temp = Math.trunc(props.weather.temp);
  const weatherIcon = props.weather.icon;

  //hvis ok
  return (
    <div
      style={{
        position: "absolute",
        bottom: 0,
        marginBottom: 140,
        display: "flex",
        alignItems: "center",
        backgroundColor: "rgba(35,35,36,0.85)",
        borderRadius: 10,
        padding: "10px 0px",
      }}
    >
      <div
        style={{
          color: "#FFF",
          borderRadius: 10,
          display: "flex",
          alignItems: "center",
          padding: "3px 10px",
          fontSize: 14,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginRight: 20,
          }}
        >
          {props.spotName}
        </div>

        {weatherIcon && (
          <div>
            <img src={iconSrc("./" + weatherIcon + ".png")} alt="" />
          </div>
        )}
        {props.weatherLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            <div style={{ marginRight: 20 }}>
              <div>{temp + "°C"}</div>
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flex: "none",
              }}
            >
              <div style={{ marginRight: 5 }}>{wind} m/s</div>
              <svg
                style={{
                  transform: `rotate(${props.weather.windDirection + 90}deg)`,
                  width: "24px",
                  height: "24px",
                  color: "white",
                }}
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
              >
                <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z" />
              </svg>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default WeatherDisplay;

const LoadingSpinner = () => {
  return (
    <svg
      className="spin"
      style={{
        height: "24px",
        width: "24px",
      }}
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="#fff"
        opacity={0.25}
        strokeWidth="4"
      />
      <path
        opacity={0.75}
        fill="#fff"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
};
